import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

import { wizardSteps, WizardSteps } from '../../../constants/wizard'

export interface WizardState {
  steps: WizardSteps
  actualStep: any
  history: string[]
  referrerUrl: string // The source url from where was routed to this app.
}

export const initialState: ImmutableGenericType<WizardState> = Immutable({
  steps: wizardSteps,
  history: ['/'],
  actualStep: {},
  referrerUrl: '',
})
